import { Link } from "wouter";
import { registrarEvento } from "../../analytics";
import { SelloSbs } from "../SelloSbs/SelloSbs";

export function Footer() {
  return (
    <footer>
      <div className="footer-menu">
        <div className="container">
          <div className="row">
            <div className="col-md-3 widget-footer">
              <p className="textoFooter">Clientes</p>
              <a href="https://msextranet.web.app/auth/acceso" target="_blank"
                 onClick={() => registrarEvento("click_acceso_extranet", { ubicacion: "footer_pagar" })}>Pagar mi cuota</a>
              <a href="https://msextranet.web.app/auth/login" target="_blank"
                 onClick={() => registrarEvento("click_acceso_extranet", { ubicacion: "footer_login" })}>Ingresa a tu cuenta</a>
              <Link to="/comoFunciona">Cómo funciona Mis Cuotas</Link>
              <Link to="/ayuda">Ayuda</Link>
            </div>
            <div className="col-md-3 widget-footer">
              <p className="textoFooter">Comercios aliados</p>
              <Link to="/paraComercios">Únete a Mis Cuotas</Link>
              <a >Contacto</a>
            </div>
            <div className="col-md-3 widget-footer">
              <p className="textoFooter">Información de interés</p>
              <Link to="/terminos-y-condiciones">Términos y condiciones</Link>
              <Link to="/politicaPrivacidad">Política de privacidad</Link>
              <Link to="/tratamiento-de-datos">Tratamiento de datos</Link>
              <Link to="/tasas-y-intereses">Tasas y tarifas</Link>
              <Link to="/acerca-de-mis-cuotas" >Acerca de Mis Cuotas</Link>
            </div>
            <div className="col-md-3 widget-footer libro-reclamaciones">
              <Link to="/libro-de-reclamaciones"
                    onClick={() => registrarEvento("click_libro_reclamaciones", { destino: "miscuotas" })}>
                {/* wouter v2 clona el hijo: sin un <a> explícito el className/href caerían en el <img> */}
                <a href="/libro-de-reclamaciones">
                  <img className="icon" src="img/logo-libro-2.png" alt="Libro de Reclamaciones" width={280} height={159} />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-contact">
        <div className="container">
          <div className="row">
            <div className="col-md-4 widget-footer">
              <a ><img src="img/logo-blanco.png" alt="" /></a>
              <SelloSbs />
            </div>
            <div className="col-md-4 widget-footer">

              <p className="textoFooter">Contáctanos</p>
              <span>Atención exclusiva por WhatsApp</span>
              <span><i className="fab fa-whatsapp" style={{ fontSize: '20px' }}></i>Escribenos al +51 967 421 523</span>
              <span style={{ fontWeight: 'bold' }}><i className="far fa-calendar-alt"></i>Horario de atención:</span>
              <span style={{ fontWeight: 'bold',  marginLeft: '25px'  }}>Lun - Vie: 9am - 6pm</span>
              <span style={{ fontWeight: 'bold',  marginLeft: '25px'  }}>Sab - Dom: 9am - 12pm</span>
              <span><i className="far fa-envelope-open"></i>Correo: servicioalcliente@miscuotas.com</span>
            </div>
            <div className="col-md-4 widget-footer">
              <p className="textoFooter">Ubícanos</p>
              <span><i className="fas fa-map-marker-alt"></i>En Comercio Afiliados</span>
              <span><i className="far fa-calendar-alt"></i>Lun – Dom de 10 am a 10 pm</span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-8 fc-text">
              Derechos Reservados © 2025 Mis Cuotas, QTC Servicios Financieros S.A.C.
            </div>
            <div className="col-md-4 fc-social">
              <div className="social-media">
                <a href="https://web.facebook.com/Mis-Cuotas-Per%C3%BA-106143618935404" target="_blank"
                   onClick={() => registrarEvento("click_red_social", { red: "facebook" })}><span className="fab fa-facebook-f"> </span></a>
                <a href="https://www.linkedin.com/company/miscuotas/" target="_blank"
                   onClick={() => registrarEvento("click_red_social", { red: "linkedin" })}><span className="fab fa-linkedin-in"></span></a>
                <a href="https://www.tiktok.com/@miscuotasperu?_t=ZM-8tsve2wbuYo&_r=1" target="_blank"
                   onClick={() => registrarEvento("click_red_social", { red: "tiktok" })}><span className="fa-brands fa-tiktok"></span></a>
                <a href="https://www.instagram.com/miscuotasperu?igsh=MTV4MmxxN29zenU2Zw==" target="_blank"
                   onClick={() => registrarEvento("click_red_social", { red: "instagram" })}><span className="fab fa-instagram"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}